import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { ModalDialog, Dialog } from '@pelckmans/business-components/components/dialog';
import { useTranslation } from 'react-i18next';
import { getFaqTutorial } from '../_api/MedialinksApi';
import { FaqTutorialItem } from '../../helpdesk/types';

type TutorialModalProps = {
  id: string;
  tutorialId: string;
  onClose: () => void;
};

export default function TutorialModal({ id, tutorialId, onClose }: TutorialModalProps) {
  const { t } = useTranslation();
  const [tutorial, setTutorial] = useState<FaqTutorialItem>();

  useEffect(() => {
    const fetchTutorial = async () => {
      const tutorial = await getFaqTutorial(tutorialId);

      setTutorial(tutorial);
    };

    fetchTutorial();
  }, [tutorialId]);

  return (
    <ModalDialog
      id={id}
      onClose={onClose}
      closeTitle={t('ACTIONS.CLOSE')}
      closeViaEscape
      closeOnClickOutside
      size="small"
      className="material-dialog embeddable-media-modal"
    >
      <Dialog.Header title={tutorial?.question || ''} />
      <Dialog.Body className={classNames({ 'bc-shimmer': !tutorial })}>
        {tutorial?.vimeoId && (
          <iframe
            src={`https://player.vimeo.com/video/${tutorial?.vimeoId}`}
            allowFullScreen
            title={tutorial?.question}
          />
        )}
      </Dialog.Body>
    </ModalDialog>
  );
}
